import { computed, action, observable } from 'mobx';
import { IDisclaimersProps } from '@kurtosys/ksys-app-components/dist/components/overview/Disclaimers/models';
import { utils, models } from '@kurtosys/ksys-app-template';
import { StoreBase } from '../../../common/StoreBase';
import { IPageDisclaimerOptions } from '../../../models/IPageDisclaimerOptions';
import { IDisclaimersConfiguration } from '../models';
import { IDisclaimerProps } from '@kurtosys/ksys-app-components/dist/components/overview/Disclaimer/models/IDisclaimerProps';

export class DisclaimersStore extends StoreBase {
	static componentKey: 'disclaimers' = 'disclaimers';

	@observable.ref
	pageDisclaimers: models.disclaimers.GlobalDisclaimerStoreValue[] = [];

	@computed
	get configuration(): IDisclaimersConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(DisclaimersStore.componentKey);
		}
	}

	@computed
	get pageDisclaimerOptions(): IPageDisclaimerOptions {
		return (this.configuration && this.configuration.pageDisclaimers) || { enabled: false };
	}

	@action
	initialize = async (): Promise<void> => {
		if (this.globalDisclaimerStore) {
			// Fire on initial
			this.handleGlobalDisclaimerChange();
			this.globalDisclaimerStore.subscribe(this.handleGlobalDisclaimerChange);
		}
	}

	@action
	handleGlobalDisclaimerChange = () => {
		console.log('handleGlobalDisclaimerChange');
		if (this.globalDisclaimerStore) {
			this.pageDisclaimers = this.globalDisclaimerStore.get(models.disclaimers.GlobalDisclaimerLevel.page);
		}
	}

	@computed
	get globalDisclaimerStore() {
		utils.globalDisclaimers.initializeGlobalDisclaimers();
		const globalDisclaimerStore = utils.globalDisclaimers.getGlobalDisclaimerStore();
		return globalDisclaimerStore;
	}

	@computed
	get props(): IDisclaimersProps {
		if (this.configuration) {
			let merged = this.mergeQueriesAndProps<IDisclaimersProps>({
				props: this.configuration.props || {},
				queries: this.configuration.queries || {},
			});
			if (this.pageDisclaimerOptions.enabled) {
				if (!merged) {
					merged = {};
				}
				if (!merged.disclaimers) {
					merged.disclaimers = [];
				}
				const { defaultProps = {} } = this.pageDisclaimerOptions;
				merged.disclaimers.push(...this.pageDisclaimers.map((pageDisclaimer) => {
					const { text, superscript, hasHtml } = pageDisclaimer;
					return {
						...defaultProps,
						text: text || defaultProps.text,
						superscript: superscript.toString() || defaultProps.superscript,
						hasHtmlContent: hasHtml || defaultProps.hasHtmlContent,

					} as IDisclaimerProps;
				}));
			}
			if (merged) {
				const { appStore } = this.storeContext;
				if (appStore && appStore.splitAppOptions) {
					const { mustLimitRows, limit, start } = appStore.splitAppOptions;
					if (mustLimitRows) {
						merged.disclaimers = (merged.disclaimers || []).filter(disclaimer => !!disclaimer.text).slice(start, start + limit);
					}
				}
				return merged;
			}
		}
		return {
			disclaimers: [],
		};
	}
}